<template>
  <div class="dialog">
    <div class="mask_wapper" v-if="show">
      <div class="mask">
        <div class="menu">
          <div class="main_box">
            <div class="main">
              <div class="main_l">
                <div
                  class="item"
                  v-for="(ele, n) in list"
                  :key="n + 'mm'"
                  :class="$route.path.includes(ele.url) ? 'item_active' : ''"
                  @click="pageto(ele.url)"
                >
                  {{ ele.title }}
                </div>
              </div>
              <div class="main_r">
                <div class="item"
                :class="$route.path.includes('/aboutHK') ? 'item_active' : ''"
                v-for="(ele, n) in items" :key="n + 'm'"
                @click="pageto2(ele.url)"
                >
                  {{ ele.name }}
                </div>
              </div>
            </div>

            <div class="info">
              <p>www.ctfleasing.com</p>
              <p>地址：重庆市两江新区黄山大道中段7号</p>
              <p>木星科技大厦（14、15楼）</p>
            </div>
          </div>

          <div class="button" @click="close">
            <div class="close"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      abhk: false,
      items: [
        { name: "公司概况", url: "/aboutHK/introduce?deep=900" },
        { name: "企业文化", url: "/aboutHK/enterpriseCul?deep=900" },
        { name: "大事记", url: "/aboutHK/events?deep=900" },
        { name: "经典案例", url: "/aboutHK/case?deep=900" },
        { name: "社会荣誉", url: "/aboutHK/social?deep=900" },
      ],
      show: false,
      list: [
        {
          title: "关于华科",
          url:'/aboutHK',
        },
        {
          title: "业务领域",
          url:'/business',
        },
        {
          title: "新闻资讯",
          url:'/news',
          
        },
        {
          title: "数字金融",
          url:'/digitization',
        },
        {
          title: "联系我们",
          url:'/contactUs',
        },
      ],
    };
  },
  methods: {
    open() {
      this.show = true;
    },
    close() {
      this.show = false;
    },
    pageto(url){
      if(url != '/aboutHK'){
        this.$router.push(url).catch(error=>{
          console.log(error);
        })
        window.scrollTo({
        top: 0,
        behavior: 'instant'
      });
      }else{
        this.$router.push(url)
        this.abhk = true;
      }
    },
    pageto2(path){
      this.close()
      this.$router.push(path).catch(error=>{
        console.log(error);
      });
      if(window.scrollY > 900){
        window.scrollTo({
        top: 901,
        behavior: 'instant'
      });
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.dialog {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 9999;
}
.mask_wapper {
  width: 100vw;
  height: 100vh;
}
.mask {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
}
.menu {
  width: 640px;
  height: 100%;
  background: #d43030;
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9999;
  animation: showMenu 0.5s ease;
  padding: 175px 150px 40px;
  box-sizing: border-box;
  .main_box{
    width: 300px;
    height: 100%;
     display: flex;
     flex-direction: column;
     justify-content: space-between;
  }
  .main {
    width: 300px;
    height: 480px;
    margin: auto;
    display: flex;
  }
  .main_l {
    width: 135px;
    height: 100%;
    border-right: solid 1px #f39090;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .item {
      width: 100px;
      height: 70px;
      line-height: 70px;
      color: #eb9c9c;
      font-size: 24px;
      cursor: pointer;
    }
    .item:hover{
      color: #fff;
    }
    .item_active {
      color: #fff;
    }
  }
  .main_r {
    flex: 1;
    height: 100%;
    padding-left: 40px;
    padding-top: 20px;
    box-sizing: border-box;
    .item {
      width: 100px;
      height: 50px;
      line-height: 50px;
      color: #eb9c9c;
      font-size: 18px;
      cursor: pointer;
    }
    .item_active {
      color: #fff;
    }
    a {
      color: #fff;
      text-decoration: none;
    }
  }

  .info {
    width: 300px;
    text-align: left;
    p {
      font-weight: 400;
      font-size: 14px;
      color: #fc9b9b;
      line-height: 36px;
    }
  }

  .button {
    width: 87px;
    height: 346px;
    background: url('../assets/button.png') no-repeat;
    background-size: 87px 346px;
    position: absolute;
    top: calc(50% - 173px);
    left: -85px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .close{
    width: 20px;
    height: 20px;
    background: url('../assets/cha.png') no-repeat;
    background-size: 20px 20px;
  }
  .close:hover {
    animation: xuanzhuang360 2s linear infinite;
  }
}

@keyframes showMenu {
  0% {
    width: 0px;
  }
  100% {
    width: 640px;
    transition: all 2s;
  }
}

@keyframes xuanzhuang180 {
  0% {
    transform: rotate(0deg);
  }
  20% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(180deg);
  }
}

@keyframes xuanzhuang360 {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>